module.exports = __webpack_public_path__ + "051b9655537f0b05bf434f6e8bdab06f.png";